import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslationsService } from '../../services';
import { TRANSLATION_LABEL_NO, TRANSLATION_LABEL_YES } from '../../constants';

@Pipe({
    name: 'booleanToYesNo',
})
export class BooleanToYesNoPipe implements PipeTransform {
    constructor(private translationsService: TranslationsService) {}

    transform(value: any): any {
        if (typeof value === 'boolean') {
            return value
                ? this.translationsService.translateTokenisedString(
                      TRANSLATION_LABEL_YES,
                  )
                : this.translationsService.translateTokenisedString(
                      TRANSLATION_LABEL_NO,
                  );
        }
        return value;
    }
}
